// initial state
const state = {
    uuid: null,
    deviceInfo: {},
    turns: [],
    serviceVersion: 'unknown',
}



// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setUuid(state, uuid) {
    state.uuid = uuid;
  },
  setDeviceInfo(state, deviceInfo) {
    state.deviceInfo = deviceInfo;
  },
  setTurns(state, turns) {
    state.turns = turns;
  },
  setServiceVersion(state, serviceVersion) {
    state.serviceVersion = serviceVersion;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}